import { styled } from 'goober';
import CrossIcon from '../../assets/checkoutWidget/cross-icon.svg';
import Style from './style.css';
import IconButton from 'preact-material-components/IconButton';
import 'preact-material-components/IconButton/style.css';
import {
  useCheckoutContext,
  useCheckoutDispatchContext,
} from '../../storeProviders/checkoutWidgetStore';

const Container = styled('div')`
  width: 100%;
  background: #ffffff;
  box-shadow: 1px 1px 6px rgba(174, 174, 174, 0.25);
  padding: 8px 16px 8px 16px;
  .iconBorder {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    line-height: 0;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iconButton {
    color: #656565;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .iconButton i {
    font-size: 20px;
  }
`;

const MainDiv = styled('div')`
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: 0px auto;
`;

const Icon = styled('div')`
  align-self: center;
`;

const RightSubContainer = styled('div')`
  padding-left: 10px;
`;

export default function Header() {
  const checkoutState = useCheckoutContext();
  const checkoutDispatch = useCheckoutDispatchContext();

  const { merchantLogo, merchantName } = checkoutState || {};

  const handleClose = () => {
    checkoutState.closeIconConfig.shouldShowCancellationPopup
      ? checkoutDispatch({
          type: 'STORE_STATE',
          payload: {
            closeIconConfig: {
              ...checkoutState.closeIconConfig,
              showCancellationPopup: true,
            }
          },
        })
      : checkoutDispatch({
          type: 'SEND_MESSAGE',
          payload: {
            payload: 'payload',
            signature: 'signature',
            actionName: 'onTransactionComplete',
          },
        });
  };

  return (
    <Container>
      <MainDiv className={Style.flexRow}>
        <div className={Style.flexRow} style={{ alignItems: 'center' }}>
          <IconButton onClick={() => {}} className='iconButton'>
            <IconButton.Icon on>arrow_back</IconButton.Icon>
            <IconButton.Icon>arrow_back</IconButton.Icon>
          </IconButton>
          <div className={Style.flexRow} style={{ alignItems: 'center' }}>
            <div className='iconBorder'>
              <img src={merchantLogo} />
            </div>
            <div style={{ marginLeft: '5px' }}>{merchantName}</div>
          </div>
        </div>
        {checkoutState.closeIconConfig.showCloseIcon && (
          <RightSubContainer className={Style.flexRow}>
            <Icon onClick={handleClose}>
              <img
                style={{ marginLeft: '15px', cursor: 'pointer' }}
                src={CrossIcon}
              />
            </Icon>
          </RightSubContainer>
        )}
      </MainDiv>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/Header.js